export default "__VITE_ASSET__DgfqBKi4__";